import axios from "axios";
import { Fragment } from "react";
import { create } from "zustand";
import { removeToken, setToken } from "../utils/API/authMethods";

export const useStore = create((set) => ({
  isAuth: false,
  user: null,
  alert: { open: false, text: "", status: "" },
  setAlert: (text, status) => {
    set({ alert: { open: true, text, status } });
  },
  closeAlert: () => {
    set({ alert: { open: false, text: "", status: "" } });
  },
  form: {
    open: false,
    formChildren: undefined,
    callBack: undefined,
    dataToUpdate: null,
  },
  setForm: (chilren, callBack, dataToUpdate) => {
    set({
      form: { open: true, formChildren: chilren, callBack, dataToUpdate },
    });
  },
  closeForm: () => {
    set({
      form: {
        open: false,
        formChildren: Fragment,
        callBack: undefined,
        dataToUpdate: { questions: [] },
      },
    });
  },

  childModal: {
    open: false,
    formChildren: undefined,
    callBack: undefined,
    dataToUpdate: null,
  },
  setChildModal: (chilren, callBack, dataToUpdate) => {
    set({
      childModal: { open: true, formChildren: chilren, callBack, dataToUpdate },
    });
  },
  closeChildModal: () => {
    set({
      childModal: {
        open: false,
        formChildren: Fragment,
        callBack: undefined,
        dataToUpdate: null,
      },
    });
  },
  login: (user, token) => {
    set({ isAuth: true, user: user });
    setToken(token);
  },
  logout: () => {
    set({ isAuth: false, user: null });
    removeToken();
  },
  setToken: () => {},
}));
